<template>
  <form class="form" v-valid.prevent="submit">
    <div class="form-item">

      <label class="cf login-db">
        <svg class="login-icon " style="font-size: 1.3em;left: -0.6em;">
          <use xlink:href="#phone"/>
        </svg>
        <input class="mr" type="tel" name="mobile" maxlength="11" required="required" pattern="1\d{10}"
               data-required="请填写手机号" data-pattern="手机号填写错误" v-model="tel" placeholder="请输入手机号码"/>
      </label>
    </div>
    <cms-item :tel="tel" v-model="pwd"/>
    <p class="c3 r">&nbsp&nbsp&nbsp</p>
    <div class="form-item" style="margin-top: 1em">
      <input type="hidden" name="type" value="2"/>
      <input class="border-btn on" type="submit" ref="doSubmit" name="submit" value="登录"/>
    </div>
  </form>
</template>

<script>
  import user from "./user";
  import cmsItem from "./cms-item.vue";

  export default {
    data() {
      return {
        api: "api/user-loginbycode",
        tel: "",
        pwd: ""     //短信验证码
      };
    },

    methods: {
      success(userinfo) {
        this.tel = "";
        this.pwd = "";
        this.complete();
        this.$emit("success", userinfo);
        user.off("success").off("fail");
        this.$router.go(-1);
      },
      fail(err) {
        this.complete();
        this.$tip(err);
        this.$emit("fail", err);
      },
      complete() {
        var btn = this.$refs.doSubmit;
        btn.disabled = false;
        btn.value = "登录";
      },
      submit() {
        var data = {
            mobile: this.tel,
            code: this.pwd
          },
          btn = this.$refs.doSubmit;
        btn.disabled = true;
        btn.value = "发送中...";
        user.on("fail", this.fail)
          .on("success", this.success)
          .login(this.api, data);
      }
    },

    components: {
      cmsItem
    }

  };
</script>
<style>
  .login-db {
    font-size: .416rem;
    height: 2.8em;
    line-height: 2.8em;
    border: 1px solid #ccc;
    color: #ccc;
    border-radius: 1.5em;
    text-align: center;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/form-code.vue